import { render } from "./CustomerDrawer.vue?vue&type=template&id=76b5f297&scoped=true"
import script from "./CustomerDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerDrawer.vue?vue&type=script&lang=js"

import "./CustomerDrawer.vue?vue&type=style&index=0&id=76b5f297&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b5f297"]])

export default __exports__